<template>
  <v-card color="#F5F5F5" class="back pa-4 mt-0 report-card">
    <v-card-title class="d-flex justify-space-between"
      ><span
        >2.5 - {{ $t('Chamados Corretivos Atendidos no Prazo') }}
        <v-tooltip color="white" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="black" dark v-bind="attrs" v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span class="black--text">{{
            $t(
              'Apresenta uma relação dos chamados e seus tempos de atendimento, de acordo com a criticidade estipulada.'
            )
          }}</span>
        </v-tooltip></span
      >
      <v-btn
        @click="requestExcel"
        depressed
        small
        class="secondary-button mr-1"
      >
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn></v-card-title
    >

    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="!haveData">
      {{ $t('Nenhum chamado encontrada') }}
    </v-alert>
    <v-card-text v-else>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <BarChart :chart-data="chartData" :options="options" />
        </v-col>
      </v-row>
    </v-card-text>

    <v-simple-table
      class="main-table"
      dense
      style="text-align: center !important"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left"></th>
            <th
              class="text-center"
              v-for="month in data.data.map((x) => x.month)"
              :key="month"
            >
              {{ month }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style="background: #67c20c">
            <td style="max-width: 60px"></td>
            <td style="max-width: 60px; color: white !important">
              {{ $t('Baixa') }}
            </td>
            <td
              style="color: white !important"
              v-for="item in data.data"
              :key="item.month"
            >
              {{
                item.lowCount +
                ' - ' +
                (item.low || item.low === 0 ? item.low : 'NA')
              }}%
            </td>
          </tr>
          <tr style="background: #dede21">
            <td style="max-width: 60px"></td>
            <td style="max-width: 60px; color: white !important">
              {{ $t('Média') }}
            </td>
            <td
              style="color: white !important"
              v-for="item in data.data"
              :key="item.month"
            >
              {{
                item.mediumCount +
                ' - ' +
                (item.medium || item.medium === 0 ? item.medium : 'NA')
              }}%
            </td>
          </tr>
          <tr style="background: red">
            <td style="max-width: 60px"></td>
            <td style="max-width: 60px; color: white !important">
              {{ $t('Alta') }}
            </td>
            <td
              style="color: white !important"
              v-for="item in data.data"
              :key="item.month"
            >
              {{
                `${
                  item.highCount +
                  ' - ' +
                  (item.high || item.high === 0 ? item.high : 'NA')
                }%`
              }}
            </td>
          </tr>
          <tr style="background: orange">
            <td style="max-width: 60px"></td>
            <td style="max-width: 60px; color: white !important">
              {{ $t('Meta') }}
            </td>
            <td
              style="color: white !important"
              v-for="item in data.data"
              :key="item.month"
            >
              {{ `${data.goal}%` }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<style scoped lang="scss">
@import '@/sass/variables.scss';
.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
.gauge {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 600px) {
  .gauge {
    height: 50vh !important;
  }
}
</style>

<script>
import ApiService from '../../../../../../services/ApiService'
import BarChart from '../../../../Reports/components/charts/barChart'

export default {
  props: {
    filterProp: Object,
  },

  components: {
    BarChart,
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      internalResolvability: undefined,
      page: 1,
      exampleValue: 50,
      totalPages: 1,
      pageSize: 7,
      val: 5,
      percent: 0,
      options: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      optionsGauge: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        series: [
          {
            type: 'gauge',
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.3, '#ED8990'],
                  [0.7, '#FDB578'],
                  [1, '#BCD504'],
                ],
              },
            },
            pointer: {
              itemStyle: {
                color: 'auto',
              },
            },
            axisTick: {
              distance: -20,
              length: 5,
              lineStyle: {
                color: '#fff',
                width: 1,
              },
            },
            splitLine: {
              distance: -20,
              length: 20,
              lineStyle: {
                color: '#fff',
                width: 3,
              },
            },
            axisLabel: {
              color: 'auto',
              distance: 15,
              fontSize: 10,
            },
            detail: {
              valueAnimation: true,
              formatter: '{value} %',
              color: 'auto',
              fontSize: 10,
            },
            data: [
              {
                value: 0,
              },
            ],
          },
        ],
      },
      chartData: {},
      requestSolicitedConclued: [],
      pieChartData: {},
      internas: [],
      internasMaisExternas: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [],
      total: 0,
      data: {
        data: [],
      },
    }
  },

  async mounted() {
    this.getData()
  },

  computed: {
    haveData() {
      return this.data.data.length > 0
    },
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `Calls_Answered_Chart_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/callsAnsweredChart', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async getData() {
      await this.apiService
        .post('reports/callsAnswered', this.filterProp)
        .then((response) => {
          this.data = response.content
        })
        .catch((err) => {})

      this.fillchartData()
    },
    fillchartData() {
      this.chartData = {
        labels: this.data.data.map((x) => x.month),
        datasets: [
          {
            label: this.$t('Alta'),
            data: this.data.data.map((x) => x.high),
            backgroundColor: 'red',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: this.$t('Média'),
            data: this.data.data.map((x) => x.medium),
            backgroundColor: '#dede21',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: this.$t('Baixa'),
            data: this.data.data.map((x) => x.low),
            backgroundColor: '#67c20c',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: 'Meta',
            type: 'line',
            data: this.data.data.map((x) => this.data.goal),
            borderColor: 'orange',
            backgroundColor: 'rgba(255,128,0,0.1)',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
        ],
      }
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.getData()
    },
    percent(nv, ov) {
      this.optionsGauge.series[0].data[0].value = nv
    },
  },
}
</script>
